import { DateTime } from 'luxon';

export const LONG_DATE_FORMAT = 'DD MMM YYYY h:mm a';
export const DAY_MONTH_YEAR_DATE_FORMAT = 'DD MMM YYYY';

export const formatFullDate = (date: Date, options?: { includeWeekday?: boolean }): string => {
  const formatOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  if (options?.includeWeekday) {
    formatOptions.weekday = 'short';
  }
  return date.toLocaleString('en', formatOptions);
};

export const formatTime = (date: Date, options?: { includeTimezone: boolean }): string => {
  const formatOptions: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  };

  if (options?.includeTimezone) {
    formatOptions.timeZoneName = 'short';
  }
  return date.toLocaleTimeString('en', formatOptions);
};

export const isSameMonthAndYear = (date1: DateTime, date2: DateTime): boolean => {
  return date1.hasSame(date2, 'month') && date1.hasSame(date2, 'year');
};
